import { type DocumentData, type QueryDocumentSnapshotModel, type QuerySnapshotModel } from "@doitintl/models-any";

export function arrayFromDocChange<T extends DocumentData, TReturn>(
  arr: TReturn[],
  querySnapshot: QuerySnapshotModel<T>,
  addProps: (item: QueryDocumentSnapshotModel<T>) => TReturn,
  filterEntity?: (model: QueryDocumentSnapshotModel<T>) => boolean
) {
  querySnapshot.docChanges().forEach((change) => {
    if (change.type === "added" || change.type === "modified") {
      const deleteCount = change.type === "added" ? 0 : 1;
      const item = addProps(change.doc);

      if (filterEntity && !filterEntity(change.doc)) {
        return;
      }
      arr.splice(change.newIndex, deleteCount, item);
    } else if (change.type === "removed") {
      arr.splice(change.oldIndex, 1);
    }
  });
}
